$(document).ready(function() {
    $(document).on('click', '.search__buttons', function(e) {
     
        e.stopPropagation(); 
        var searchBar = $('.PwsSeacrinput');
        if (searchBar.css('display') === 'none') {
            searchBar.css('display', 'block');
            $('.PwsSearchForm').addClass('openSearchBar');
        } else {
            searchBar.css('display', 'none');
              $('.PwsSearchForm').removeClass('openSearchBar');
        }
    });
    $(document).on('click', '.PwsSeacrinput', function(e) {
        e.stopPropagation();

    });
    $(document).on('click', function() {
        $('.PwsSeacrinput').css('display', 'none');
        
    });
    

var $carousel = $('.carousel-main');
var $barDotsContainer = $('.slick-bar-dots');

$carousel.on('init', function(event, slick) {
  // create bars dynamically based on number of slides
  for (var i = 0; i < slick.slideCount; i++) {
    $barDotsContainer.append('<div class="bar-dot" data-slide="' + i + '"><span class="bar"></span></div>');
  }
  setActiveBar(0);
});

$carousel.on('afterChange', function(event, slick, currentSlide) {
  setActiveBar(currentSlide);
});

// click navigation
$barDotsContainer.on('click', '.bar-dot', function() {
  var slideIndex = $(this).data('slide');
  if ($.fn.slick) $carousel.slick('slickGoTo', slideIndex);
});

function setActiveBar(index) {
  $('.bar-dot').removeClass('active');
  $('.bar-dot').eq(index).addClass('active');
}

// slick.js is only loaded on product pages (theme.liquid); guard so the rest of
// this ready-block (global add-to-cart delegation below) survives elsewhere.
if ($carousel.length && typeof $.fn.slick === 'function')
$carousel.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
    
  $(document).on('click','.Section_btn',function(){
    $('.drawer_section').addClass('clickBtn');
  });

  $(document).on('click','.drawer-close-btn',function(){
    // alert('close');
    $('.drawer_section').removeClass('clickBtn');
  });

  // Click a size on any product card -> add that variant to cart. Delegated on document so
  // it works for cards injected asynchronously too (Recently Viewed via Section Rendering
  // API, You May Also Like via recommendations) whose inline <script> never executes.
  $(document).off('click.addtocart', '.size-variant').on('click.addtocart', '.size-variant', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this);
    if ($btn.hasClass('unavailable') || $btn.attr('aria-disabled') === 'true') return;
    var variantId = $btn.attr('data-size-id');
    if (!variantId) return;
    if ($btn.hasClass('is-loading')) return;
    $btn.addClass('is-loading');
    $('.size-variant').removeClass('selected');
    $btn.addClass('selected');
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsParam = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble', 'cart-drawer', 'cart-live-region-text'];
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      contentType: 'application/json',
      data: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: sectionsParam, sections_url: window.location.pathname }),
      dataType: 'json',
      success: function (parsedState) {
        $btn.removeClass('is-loading');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') { cartDrawer.renderContents(parsedState); }
          else if (typeof cartDrawer.open === 'function') { cartDrawer.open(); }
        }
      },
      error: function (err) { $btn.removeClass('is-loading'); console.log('Failed to add to cart', err); }
    });
  });

  $('.card-wrapper').each(function() {
    var card = $(this);
    var container = card.find('.PwsAppend_swatchimage');
    var regularPrice = card.find('.SingleRegular_Price');

    card.find('.PWscolor-swatch').hover(function() {
      var imgUrl = $(this).attr('data-product-image');
      var regularprice = $(this).attr('data-product-money');
      if(imgUrl) {
        container.append(
          '<img class="hover-swatch-img" src="' + imgUrl + '" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover;" />'
        );
      }
      
    });

  });










  
});

document.addEventListener("DOMContentLoaded", function() {
  const desc = document.querySelector(".product__description");
  const btn = document.querySelector(".learn-more-btn");
  if (!desc || !btn) return;

  // Apply line-clamp first to measure the exact pixel height of N lines.
  // This becomes the "collapsed target" for the max-height animation later.
  desc.classList.add("is-collapsed");
  const collapsedHeight = desc.clientHeight;

  // If description already fits within collapsed height, hide the button entirely.
  if (desc.scrollHeight <= collapsedHeight + 1) {
    btn.style.display = "none";
    desc.classList.remove("is-collapsed");
    return;
  }

  // Static states are governed by .is-collapsed class (line-clamp, perfectly aligned).
  // The slide-in / slide-out transition uses max-height animation in between.
  desc.style.overflow = "hidden";
  desc.style.transition = "max-height 0.4s ease";

  let expanded = false;

  btn.addEventListener("click", function() {
    if (expanded) {
      // Expanded → Collapsed: anchor at current full height, then animate down.
      desc.style.maxHeight = desc.scrollHeight + "px";
      desc.offsetHeight; // force reflow so the next change triggers a transition
      desc.style.maxHeight = collapsedHeight + "px";
      btn.textContent = "Show more";
      btn.classList.remove("is-expanded");
      expanded = false;
      // After the slide-out finishes, snap to the clean line-clamp state and release inline maxHeight.
      const onEnd = function(e) {
        if (e.propertyName !== "max-height") return;
        desc.classList.add("is-collapsed");
        desc.style.maxHeight = "";
        desc.removeEventListener("transitionend", onEnd);
      };
      desc.addEventListener("transitionend", onEnd);
    } else {
      // Collapsed → Expanded: anchor at the clamped height, drop line-clamp, then animate up to full.
      desc.style.maxHeight = collapsedHeight + "px";
      desc.classList.remove("is-collapsed");
      desc.offsetHeight; // force reflow before transitioning to scrollHeight
      desc.style.maxHeight = desc.scrollHeight + "px";
      btn.textContent = "Show less";
      btn.classList.add("is-expanded");
      expanded = true;
      // After the slide-in finishes, drop the inline maxHeight so natural reflow works.
      const onEnd = function(e) {
        if (e.propertyName !== "max-height") return;
        desc.style.maxHeight = "";
        desc.removeEventListener("transitionend", onEnd);
      };
      desc.addEventListener("transitionend", onEnd);
    }
  });
});

// A11y: Owl Carousel renders its nav buttons with no text and role="presentation",
// failing the "buttons have an accessible name" audit. Label them after init.
function fixOwlNavA11y() {
  document.querySelectorAll('button.owl-prev, button.owl-next, button.owl-dot').forEach(function (b) {
    if (!b.getAttribute('aria-label')) {
      var label = b.classList.contains('owl-prev') ? 'Previous slide'
        : b.classList.contains('owl-next') ? 'Next slide' : 'Go to slide';
      b.setAttribute('aria-label', label);
    }
    if (b.getAttribute('role') === 'presentation') b.removeAttribute('role');
  });
}
// Run at several moments AND watch the DOM — Owl creates / re-creates its nav
// buttons at unpredictable times (init, refresh, image load), so a single
// load-time pass can miss them.
document.addEventListener('DOMContentLoaded', fixOwlNavA11y);
window.addEventListener('load', function () {
  fixOwlNavA11y();
  setTimeout(fixOwlNavA11y, 1500);
  setTimeout(fixOwlNavA11y, 4000);
});
(function () {
  if (!('MutationObserver' in window)) return;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && (n.matches('.owl-nav, .owl-dots, button.owl-prev, button.owl-next, button.owl-dot') || n.querySelector && n.querySelector('button.owl-prev, button.owl-next, button.owl-dot')))) {
          fixOwlNavA11y();
          return;
        }
      }
    }
  });
  var start = function () { mo.observe(document.body, { childList: true, subtree: true }); setTimeout(function () { mo.disconnect(); }, 15000); };
  document.body ? start() : document.addEventListener('DOMContentLoaded', start);
})();

/* PDP accordions (Features / Shipping & Returns / Crash Replacement):
   slide open and closed — same 0.4s ease as the description's "Show more" —
   one open at a time, and keep everything ABOVE the panels still while they
   move. Animates the <details> height between the summary row and its full
   height, so the content's own (!important) padding is never touched.

   Opening a panel slides the open one shut at the same time. On desktop the
   product info column is sticky. Once the page is scrolled far enough it rests
   on the bottom of its wrapper, so panels growing would push the column's top
   (title, price, sizes) up and panels shrinking would pull it down. While panels
   slide we move that resting point instead: the wrapper grows (min-height) as
   the column grows, and the column keeps a matching gap under it (margin-bottom)
   as it shrinks. The page is never scrolled for this; if the shopper scrolls
   mid-slide we hold from there.

   When the panel closing sits above the one clicked, the clicked one has to
   ride up — but never under the site header: past that point the column comes
   down with it (on phones, where nothing is sticky, the page scrolls instead).
   Reduced-motion users get the native toggle, still one open at a time. */
(function () {
  if (window.__pdpAccordionSlide) return;
  window.__pdpAccordionSlide = true;

  var DURATION = 400;
  var EASING = "ease";
  var reduceMotion = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;

  function setGap(col, gap) {
    col._gap = gap > 0.5 ? gap : 0;
    col.style.marginBottom = col._gap ? col._gap + "px" : "";
  }

  // Highest a clicked summary may ride: just under the sticky site header.
  function lowestTop(summary) {
    var header = document.querySelector(".section-header");
    var under = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 8;
    return Math.min(under, summary.getBoundingClientRect().top); // already higher: leave it there
  }

  // Keeps the sticky info column's top where it is until stop() runs. keep(summary)
  // re-anchors to the column's current spot and lets the column come down just
  // enough that this summary never rides up under the header.
  function holdColumn(col) {
    var wrap = col.parentElement;
    var top = col.getBoundingClientRect().top;
    var keepEl = null;
    var keepMin = 0;
    var raf = 0;
    var stopped = false;
    col._holds = (col._holds || 0) + 1;

    function target() {
      if (!keepEl) return top;
      return Math.max(top, keepMin - (keepEl.getBoundingClientRect().top - col.getBoundingClientRect().top));
    }
    function drift() { return col.getBoundingClientRect().top - target(); } // < 0: pushed up
    function wrapHeight() { return wrap.getBoundingClientRect().height; }
    function onScroll() { // the shopper moved the page
      top = col.getBoundingClientRect().top;
      if (keepEl) keepMin = lowestTop(keepEl);
    }

    function hold() {
      var d = drift();
      if (Math.abs(d) < 0.5) return;
      var gap = col._gap || 0;
      var minHeight = wrap.style.minHeight;
      if (d < 0 && gap) {
        setGap(col, gap + d); // grew: use up the gap under the column first…
      } else if (d < 0) {
        wrap.style.minHeight = wrapHeight() - d + "px"; // …then let the wrapper reach further down
      } else if (minHeight) {
        wrap.style.minHeight = wrapHeight() - d + "px"; // shrank: hand back wrapper height first…
        if (drift() > 0.5) wrap.style.minHeight = ""; // (it's back to its natural height)
      } else {
        setGap(col, gap + d); // …then leave a gap under the column
      }
      var left = drift();
      if (Math.abs(left) > Math.abs(d) - 0.5) {
        // Didn't help, so the column isn't resting on the wrapper — leave things as they were.
        setGap(col, gap);
        wrap.style.minHeight = minHeight;
      } else if (Math.abs(left) >= 0.5) {
        hold(); // finish with the other lever
      }
    }

    function loop() {
      hold();
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    window.addEventListener("scroll", onScroll, { passive: true });

    return {
      keep: function (summary) {
        top = col.getBoundingClientRect().top;
        keepEl = summary;
        keepMin = lowestTop(summary);
      },
      stop: function () {
        if (stopped) return;
        stopped = true;
        col._holds--;
        cancelAnimationFrame(raf);
        window.removeEventListener("scroll", onScroll);
        hold();
        // Drop the extra room if the column stays put without it (e.g. near the
        // top of the page). All or nothing: once the column is off its resting
        // point, a smaller amount wouldn't put it back.
        var gap = col._gap || 0;
        var minHeight = wrap.style.minHeight;
        if (gap || minHeight) {
          setGap(col, 0);
          wrap.style.minHeight = "";
          if (Math.abs(drift()) >= 0.5) {
            setGap(col, gap);
            wrap.style.minHeight = minHeight;
            window.addEventListener("scroll", tidySoon, { passive: true });
          }
        }
      }
    };
  }

  // Phones: nothing is sticky, so only keep the clicked summary from riding up
  // under the header — by scrolling the page.
  function holdInView() {
    var keepEl = null;
    var keepMin = 0;
    var raf = 0;
    function fix() {
      var over = keepMin - keepEl.getBoundingClientRect().top;
      if (over > 0.5) window.scrollBy(0, -over);
    }
    function onScroll() { keepMin = lowestTop(keepEl); }
    function loop() {
      fix();
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    window.addEventListener("scroll", onScroll, { passive: true });
    return {
      keep: function (summary) {
        keepEl = summary;
        keepMin = lowestTop(summary);
      },
      stop: function () {
        cancelAnimationFrame(raf);
        window.removeEventListener("scroll", onScroll);
        fix();
      }
    };
  }

  // Whatever is left only matters while the column sits where the shopper left
  // it. Once they've scrolled on, drop it wherever that can't be seen, so the
  // page gets its natural length back.
  var tidyTimer = 0;
  function tidySoon() {
    clearTimeout(tidyTimer);
    tidyTimer = setTimeout(tidy, 200);
  }
  function tidy() {
    var left = false;
    document.querySelectorAll(".product__info-container").forEach(function (col) {
      var wrap = col.parentElement;
      if (!wrap || !(col._gap || wrap.style.minHeight)) return;
      if (!col._holds && getComputedStyle(col).position === "sticky") {
        var gap = col._gap;
        var minHeight = wrap.style.minHeight;
        holdColumn(col).stop(); // drops it all if the column stays put without it
        if (wrap.getBoundingClientRect().bottom < window.innerHeight) {
          setGap(col, gap); // what's below the product is on screen — leave it be
          wrap.style.minHeight = minHeight;
        }
      }
      if (col._gap || wrap.style.minHeight) left = true;
    });
    if (!left) window.removeEventListener("scroll", tidySoon);
  }

  // The held layout is only right for the current width.
  var lastWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    document.querySelectorAll(".product__info-container").forEach(function (col) {
      setGap(col, 0);
      if (col.parentElement) col.parentElement.style.minHeight = "";
    });
  });

  // One hold per column (or per page, on phones) while any of its panels slides.
  function holderFor(details) {
    var col = details.closest(".product__info-container");
    if (col && col.parentElement && getComputedStyle(col).position === "sticky") {
      if (!col._hold) col._hold = holdColumn(col);
      return col;
    }
    var root = document.documentElement;
    if (!root._hold) root._hold = holdInView();
    return root;
  }

  // A slide under this holder has ended; the last one out lets the column go.
  function done(holder) {
    if (--holder._sliding > 0) return;
    holder._sliding = 0;
    var hold = holder._hold;
    holder._hold = null;
    if (hold) hold.stop();
  }

  function openSiblings(details) {
    var group = details.closest(".product__info-container, .cstm-main-product-desc");
    if (!group) return [];
    return [].filter.call(group.querySelectorAll(".product__accordion--group details[open]"), function (d) {
      return d !== details && !d.classList.contains("is-closing");
    });
  }

  function settle(details) {
    details.style.height = "";
    details.style.overflow = "";
    details.classList.remove("is-closing");
    details._slide = null;
  }

  function slide(details, opening, holder) {
    var summary = details.querySelector(":scope > summary");
    // Clip first, then measure: overflow:hidden keeps the content's bottom
    // margin inside the panel, so the panel takes the same room mid-slide as
    // before and after it (measured unclipped, everything below hopped 15px as
    // a slide ended). Measure before cancelling, so a re-click mid-slide
    // reverses smoothly from wherever it is instead of jumping.
    details.style.overflow = "hidden";
    var start = details.getBoundingClientRect().height;
    if (details._slide) {
      details._slide.onfinish = null;
      details._slide.cancel();
    }
    if (!details._slide || details._holder !== holder) {
      if (details._slide) done(details._holder); // layout changed mid-slide
      holder._sliding = (holder._sliding || 0) + 1;
    }
    details._holder = holder;

    var end;
    if (opening) {
      details.classList.remove("is-closing");
      details.open = true;
      end = details.getBoundingClientRect().height;
      details.style.height = start + "px";
    } else {
      details.classList.add("is-closing"); // caret turns back as the slide starts
      end = summary.getBoundingClientRect().height;
    }

    var anim = details.animate(
      [{ height: start + "px" }, { height: end + "px" }],
      { duration: DURATION, easing: EASING }
    );
    details._slide = anim;
    anim.onfinish = function () {
      if (!opening) details.open = false;
      settle(details);
      details._holder = null;
      done(holder);
    };
  }

  document.addEventListener("click", function (e) {
    var summary = e.target.closest && e.target.closest(".product__accordion details > summary");
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== "DETAILS") return;
    var opening = !details.open || details.classList.contains("is-closing");
    var others = opening ? openSiblings(details) : [];
    if ((reduceMotion && reduceMotion.matches) || !details.animate) {
      others.forEach(function (d) { d.open = false; }); // native toggle, still one open at a time
      return;
    }

    e.preventDefault();
    var holder = holderFor(details);
    holder._hold.keep(summary);
    slide(details, opening, holder);
    others.forEach(function (d) { slide(d, false, holder); });
  });
})();
